import Cookies from 'universal-cookie';

// In-memory flag so ProtectedRoute can read expiry synchronously
// (before React state from the session-expired event has committed).
// Intentionally not sessionStorage — a full page reload should send the user
// to login cleanly rather than trapping them on a token-less protected route.
let sessionExpired = false;

const cookies = new Cookies();
const DEFAULT_EXPIRES_IN_SEC = 3600;

export function markSessionExpired() {
    sessionExpired = true;
    window.dispatchEvent(new CustomEvent('session-expired'));
}

export function clearSessionExpiredFlag() {
    sessionExpired = false;
}

export function isSessionExpiredSync() {
    return sessionExpired;
}

export function persistAuthSession(data) {
    const expiresIn = Number(data.expiresIn) > 0 ? Number(data.expiresIn) : DEFAULT_EXPIRES_IN_SEC;
    localStorage.setItem('token', data.accessToken);
    if (data.refreshToken) {
        localStorage.setItem('refreshToken', data.refreshToken);
    }
    localStorage.setItem('tokenExpiresAt', String(Date.now() + expiresIn * 1000));
    cookies.set('token', data.accessToken, { path: '/', maxAge: expiresIn });

    if (Array.isArray(data.tenants)) {
        localStorage.setItem('tenants', JSON.stringify(data.tenants));
    } else {
        localStorage.removeItem('tenants');
    }
    localStorage.removeItem('currentTenant');

    localStorage.removeItem('userTenantData');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('userPermissions');
    localStorage.removeItem('userRoles');

    window.dispatchEvent(new Event('app:tokenChanged'));
}

export function clearAuthSession() {
    cookies.remove('token', { path: '/' });
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('tokenExpiresAt');
    localStorage.removeItem('tenants');
    localStorage.removeItem('currentTenant');
    localStorage.removeItem('userTenantData');
    localStorage.removeItem('userProfile');
    localStorage.removeItem('userPermissions');
    localStorage.removeItem('userRoles');
}

export function hasFlowAccess(tenantData) {
    if (!Array.isArray(tenantData) || tenantData.length === 0) {
        return false;
    }

    return tenantData.some((tenant) =>
        (Array.isArray(tenant.roles) && tenant.roles.length > 0)
        || (Array.isArray(tenant.permissions) && tenant.permissions.length > 0)
    );
}

export function resolvePostAuthPath(tenantData) {
    return hasFlowAccess(tenantData) ? '/home' : '/onboarding/pending';
}

export function filterTenantsForFlowAccess(tenants, tenantData) {
    if (!Array.isArray(tenants) || tenants.length === 0) {
        return [];
    }

    const allowedIds = new Set(
        (Array.isArray(tenantData) ? tenantData : [])
            .filter((entry) => hasFlowAccess([entry]))
            .map((entry) => String(entry.tenant_id))
    );

    if (allowedIds.size === 0) {
        return tenants;
    }

    const filtered = tenants.filter((tenant) => allowedIds.has(String(tenant.id)));
    return filtered.length > 0 ? filtered : tenants;
}
